<template>
    <v-container class="h-100">
        <v-card v-if="showPartnerDetail==false" class="card-container">
            <v-card-title>
                <v-row>
                    <v-col cols="auto">
                        <v-btn
                                dense
                                color="var(--color-blue)"
                                @click="showAddModal"
                                dark
                        >
                            <span class="btn-text"><v-icon dark>add</v-icon> Добавить партнера</span>
                        </v-btn>
                    </v-col>
                    <v-col >
                        <v-text-field
                                class="search-block"
                                v-model="search"
                                prepend-inner-icon="mdi-magnify"
                                single-line
                                solo
                                placeholder="Поиск партнера"
                                dense
                                hide-details
                        />
                    </v-col>

                </v-row>

            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="h-100 p-0" style="overflow-y: scroll">
                <v-data-table
                        :loading="loading"
                        no-data-text="Нет элементов"
                        no-results-text="Не найдено элементов"
                        loading-text="Загрузка данных"
                        calculate-widths
                        :items-per-page="filteredItems.length"
                        :items="filteredItems"
                        :headers="fields"
                        :search="search"
                        height="100%"
                        hide-default-footer
                        class="elevation-1 h-100"
                >
                    <template v-slot:item.smallLogo="{item}">
                        <img
                                class="my-1"
                                v-if="item.smallLogo!=null"
                                :src="$root.docsUrl+item.smallLogo"
                                alt="лого"
                                height="50px"
                                width="50px"
                        >
                        <img class="my-1" v-else src="../assets/noavatar.png" height="50" width="50"/>
                    </template>

                    <template v-slot:item.edit="{item}">
                        <v-btn icon @click="showDetails(item)">
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>

        <partnerDetails v-else :item="selected" @hideDetails="hideDetails"></partnerDetails>

        <b-modal
                id="modalAdd"
                centered
                size="lg"
                title="Добавление новой записи"
        >
            <b-container fluid>
                <div class="custom-group-label mb-2">Данные</div>
                <b-row no-gutters class="mb-2">
                    <b-col>
                        <label class="custom-input-label">Наименование организации</label>
                        <b-input
                                v-model="editModel.orgName"
                                required
                                :state="errors.findIndex(x=>x.key='orgName')!=-1?editModel.orgName!=null?true:false:null"
                        />
                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-2">
                    <b-col>
                        <label class="custom-input-label">Описание</label>
                        <b-textarea
                                v-model="editModel.description"
                                required
                                rows="6"
                        />
                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-2">
                    <b-col>
                        <label class="custom-input-label">Сайт</label>
                        <b-input v-model="editModel.siteURL"/>
                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-1">
                    <b-col>
                        <b-form-checkbox
                                v-model="editModel.vip"
                                size="lg"
                        >
                                <span class="custom-group-label"
                                      style="margin-left: 5px;">VIP статус</span>

                        </b-form-checkbox>

                    </b-col>
                </b-row>
                <b-row class="mb-1">
                    <b-col
                            xs="7"
                            sm="3"
                            md="7"
                            lg="3"
                            xl="3">
                        <imageLoader :ratioH="1" size="small" textLabel="Фотография профиля организации (354 x 354)"
                                     @file-loaded="smallLogoLoaded"></imageLoader>
                    </b-col>
                </b-row>
                <b-row class="mb-1">
                    <b-col
                            xs="10"
                            sm="6"
                            md="6"
                            lg="6"
                            xl="6">
                        <imageLoader textLabel="Фотография страницы (1080 x 540)"
                                     @file-loaded="logoLoaded"></imageLoader>

                    </b-col>
                </b-row>
                <div class="custom-group-label mb-2">Специализация:</div>
                <b-row no-gutters class="mb-1">
                    <b-col>
                        <b-form-checkbox
                                v-model="editModel.canAddClient"
                                size="lg"
                        >
                                <span class="custom-group-label"
                                      style="margin-left: 5px;">Добавление клиентов</span>

                        </b-form-checkbox>

                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-1">
                    <b-col>
                        <b-form-checkbox
                                v-model="editModel.canExecuteRequest"
                                size="lg"
                        >
                                <span class="custom-group-label"
                                      style="margin-left: 5px;">Прием заявок</span>

                        </b-form-checkbox>

                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-1">
                    <b-col>
                        <b-form-checkbox
                                v-model="editModel.canManageBonus"
                                size="lg"
                                class="checkb"
                        >
                                <span class="custom-group-label"
                                      style="margin-left: 5px;">Активация бонусов</span>

                        </b-form-checkbox>

                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-1">
                    <b-col>
                        <b-form-checkbox
                                v-model="editModel.canAddStocks"
                                class="custom-checkbox-flag"
                                size="lg"
                                primary
                        >
                                <span class="custom-group-label"
                                      style="margin-left: 5px;">Добавление акций</span>

                        </b-form-checkbox>

                    </b-col>
                </b-row>




            </b-container>
            <template v-slot:modal-footer>
                <div class="w-100">
                    <v-row no-gutters justify="space-between">

                        <v-spacer></v-spacer>
                        <v-col cols="auto" class="mr-2">
                            <v-btn
                                    color="var(--color-blue)"
                                    dark
                                    size="sm"
                                    @click="onSave"
                            >
                                Сохранить
                            </v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn
                                    class="cancel-btn"
                                    outlined
                                    color="var(--color-3)"
                                    size="sm"
                                    @click="$bvModal.hide('modalAdd')"
                            >
                                Отмена
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </template>
        </b-modal>

    </v-container>

</template>
<script>
    import mapper from 'automapper'
    import axios from 'axios'
    import partnerDetails from '../components/Partners/PartnerInfo.vue'
    import imageLoader from '../components/ImageLoader.vue'

    export default {
        name: "Organizations",
        components: {partnerDetails, imageLoader},
        data() {
            return {
                showPartnerDetail: false,
                errors: [],
                selectedTypes: [],
                search: "",
                imageModel: null,
                loading: false,
                imageModelBig: null,
                editModel: {
                    id: null,
                    orgName: null,
                    description: null,
                    siteURL: null,
                    smallLogo: null,
                    bigLogo: null,
                    vip: false,
                    canAddClient: false,
                    canExecuteRequest: false,
                    canManageBonus: false,
                    canAddStocks: false
                },
                fields: [
                    {text: 'Лого', value: 'smallLogo'},
                    {
                        text: 'Название',
                        value: 'orgName',
                        sortable: true
                    },
                    {text: 'Краткое описание', value: 'shortDescription'}, {text: 'Сайт', value: 'siteURL'},
                    {text: '', value: 'edit'}
                ],
                selected: null,
            }
        },
        computed: {
            filteredItems() {
                var items = this.$store.state.Partners.items;
                if (items != null) {
                    return items.filter((elem) => {
                        return new RegExp(this.search, 'ig').test(elem.orgName);
                    }).sort((a, b) => {
                        var nameA = a.orgName.toLowerCase(), nameB = b.orgName.toLowerCase()
                        if (nameA < nameB) //сортируем строки по возрастанию
                            return -1
                        if (nameA > nameB)
                            return 1
                        return 0
                    });
                }
                else return [];
            },
        },
        created() {
            const vm = this;
            this.loading = true
            //заполняем данные справочника
            this.$store.dispatch("Partners/loadOrganizations").then(x => vm.loading = false).catch((err) => {
                vm.loading = false
                this.$bvToast.toast(err.message, {
                    title: `Ошибка загрузки организаций!`,
                    variant: "danger",
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 3000,
                    solid: true
                })
            })

            if (this.$store.state.PartnerTypes.items.length == 0) {
                this.$store.dispatch("PartnerTypes/loadPartnerTypes").catch((err) => {
                    console.log(err)
                    this.$bvToast.toast(err.message, {
                        title: `Ошибка загрузки списка типов партнеров!`,
                        variant: "danger",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                });
            }

            mapper.createMap("orgModel", "orgEditModel")
        },
        methods: {
            smallLogoLoaded(e) {
                this.imageModel = e[0]
            },

            logoLoaded(e) {
                this.imageModelBig = e[0]
            },

            toggleAllTypes() {
                this.$nextTick(() => {
                    if (this.likesAllTypes) {
                        this.selectedTypes = []
                    }
                    else {
                        this.selectedTypes = []
                        this.partnerTypes.forEach(item => {
                            this.selectedTypes.push(item.id)
                        })
                    }
                })
            },

            showDetails(item) {
                this.selected = item
                this.showPartnerDetail = true
            },
            hideDetails(isSave) {
                this.selected = null
                this.showPartnerDetail = false
                if(isSave){
                    this.$store.dispatch("PartnerTypes/loadPartnerTypes").catch((err) => {
                        this.$bvToast.toast(err.message, {
                            title: `Ошибка загрузки списка типов партнеров!`,
                            variant: "danger",
                            toaster: 'b-toaster-bottom-right',
                            autoHideDelay: 3000,
                            solid: true
                        })
                    });
                }
            },

            showAddModal() {
                this.resetModel();
                this.$bvModal.show('modalAdd')
            },

            resetModel() {
                //обнуляем поля
                for (var key in this.editModel) {
                    if (key == 'vip'||key == 'canAddClient'||key == 'canExecuteRequest'||key == 'canManageBonus'||key == 'canAddStocks')
                        this.editModel[key] = false;
                    else
                        this.editModel[key] = null;
                }
                this.imageModel = null;
            },


            validateModel() {
                var noError = true;
                this.errors = [];
                if (this.editModel.orgName == null || this.editModel.orgName == '') {
                    this.errors.push({key: "orgName", mes: "Необходимо указать название!"});
                    noError = false;
                }
                return noError;
            },

            async onSave() {
                if (this.validateModel() == true) {
                    const vm = this;
                    try {
                        //если была изменена картинка, то загружаем на сервер
                        if (this.imageModel != null) {
                            var imgId = null;
                            const imgData = new FormData();
                            imgData.append('files', this.imageModel);
                            await axios.post(`${vm.$root.baseUrl}:8085/api/FileUpload`, imgData)
                                .then(response => imgId = response.data[0])
                                .catch(error => {
                                    console.log(error)
                                });
                            if (imgId != null)
                                this.editModel.smallLogo = imgId;
                        }

                        //загружаем большой логотип
                        if (this.imageModelBig != null) {
                            var imgId = null;
                            const imgData = new FormData();
                            imgData.append('files', this.imageModelBig);
                            await axios.post(`${vm.$root.baseUrl}:8085/api/FileUpload`, imgData)
                                .then(response => imgId = response.data[0])
                                .catch(error => {
                                    console.log(error)
                                });
                            if (imgId != null)
                                this.editModel.bigLogo = imgId;
                        }

                        this.$store.dispatch('Partners/addOrganization', this.editModel).then(() => {
                            this.$bvModal.hide('modalAdd')
                            this.loading = true
                            //заполняем данные справочника
                            this.$store.dispatch("Partners/loadOrganizations").then(x => vm.loading = false).catch((err) => {
                                vm.loading = false
                                this.$bvToast.toast(err.message, {
                                    title: `Ошибка загрузки организаций!`,
                                    variant: "danger",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            })
                            this.$bvToast.toast("Организация успешно добавлена", {
                                variant: "success",
                                toaster: 'b-toaster-bottom-right',
                                autoHideDelay: 3000,
                                solid: true
                            })

                        }).catch(err => {
                            this.$bvToast.toast(err.message, {
                                title: `Ошибка!`,
                                variant: "danger",
                                toaster: 'b-toaster-bottom-right',
                                autoHideDelay: 3000,
                                solid: true
                            })
                        });

                    } catch (e) {
                        console.log(e)
                    }
                }
                else {
                    this.errors.forEach(err => {
                        this.$bvToast.toast(err.mes, {
                            title: `Не все поля заполнены!`,
                            variant: "warning",
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 7000,
                            solid: true
                        })
                    })
                }
            },
        },
    }
</script>

<style lang="scss">
    .custom-control > label::before {
       border-radius: 0 !important;
    }
    .custom-checkbox .custom-control-input:checked~.custom-control-label::before{
        background-color:var(--color-blue);
        margin-top: 3px;
    }
    .custom-checkbox .custom-control-input:checked~.custom-control-label::after{
        margin-top: 3px;
    }
    .custom-checkbox .custom-control-label::before{
        margin-top: 3px;
    }

</style>
